import React from 'react';
import { Container } from 'react-bootstrap';

const Contact = () => {
  return (
    <main>
      <section className='hero'>
        <Container>
          <h1>Contact</h1>
        </Container>
      </section>
      <section className='section-steel-blue'></section>
    </main>
  );
};

export default Contact;
